import { Component } from 'react';
import {Footer, SideNav, TopBar} from '../partials/layouts.js';
import {LogoutModal} from './logout.js';
import {postData, updateData, deleteItem} from './constants.js';
const moment = require('moment');

class EmailEventList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data       :[],
      user_roles :[],
      isLoading  :true,
      show       :false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleMultiSelectChange = this.handleMultiSelectChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.addEmailEvent = this.addEmailEvent.bind(this);
    this.editEmailEvent = this.editEmailEvent.bind(this);
    this.deleteEmailEvent = this.deleteEmailEvent.bind(this);
    this.viewEmailEvent = this.viewEmailEvent.bind(this);
  }

  async getEmailEvents() {
    try {
      const response = await fetch('/api/email-events');
      const json = await response.json();
      this.setState({ data: json.email_events, user_roles:json.roles });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    this.getEmailEvents();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleMultiSelectChange(event) {
    const target = event.target;
    const selected_value = target.selectedOptions[0].value;
    var values = this.state.roles;
    console.log(values);
    if(selected_value){
      const index = values.indexOf(selected_value);
      if(index < 0){
        console.log(selected_value);
        values.push(selected_value);
      }else{
        values.splice(index, 1);
      }
    }else{
      values = [];
    }
    this.setState({ roles : values });
  }

  handleSubmit(event) {
    event.preventDefault();
    const data = this.state;
    this.setState({ show: false, isLoading: true });
    delete data.data;
    delete data.isLoading;
    if(data.id){
      updateData('/api/email-event/'+data.id, data)
        .then((response) => {
          console.log(response);
          this.getEmailEvents();
      });
    }else{
      postData('/api/email-event', data)
        .then((response) => {
          console.log(response);
          this.getEmailEvents();
      });
    }
  }

  addEmailEvent() {
    this.setState({
      id            :"",
      event_name    :"",
      template_key  :"",
      roles         :[],
      show_content  :"form",
      show          :true
    });
  }

  viewEmailEvent(e) {
    const id = parseInt(e.target.id);
    const email_events = this.state.data;
    const selectedEmailEvent = email_events.filter(e=> e.id === id)[0];
    this.setState(selectedEmailEvent);
    this.setState({ show: true, show_content: "view" });
  }

  editEmailEvent(e) {
    const id = parseInt(e.target.id);
    const email_events = this.state.data;
    const selectedEmailEvent = email_events.filter(e=> e.id === id)[0];
    this.setState(selectedEmailEvent);
    this.setState({ show: true, show_content: "form" });
  }

  deleteEmailEvent(e) {
    const id = parseInt(e.target.id);
    deleteItem("/api/email_event/"+id)
    .then((response) => {
      console.log(response);
      this.getEmailEvents();
    });
  }

  render() {
    if(!this.state.isLoading){
      const email_events = this.state.data;
      const email_event_list = email_events.map((event)=>
          <tr key={event.id} id={event.id}>
            <td>{event.event_name}</td>
            <td>{event.template_key}</td>
            <td className="text-wrap">{JSON.stringify(event.roles)}</td>
            <td>
              <div className="row no-gutters">
                <div className="col">
                  <i id={event.id} className="fas fa-info-circle text-info action-icons" onClick={this.viewEmailEvent}></i>
                </div>
                <div className="col">
                  <i id={event.id} className="fas fa-pencil-alt text-warning action-icons mx-2" onClick={this.editEmailEvent}></i>
                </div>
                <div className="col">
                  <i id={event.id} className="fas fa-trash-alt text-danger action-icons" onClick={this.deleteEmailEvent}></i>
                </div>
              </div>
            </td>
          </tr>
      );
      const role_opts = this.state.user_roles.map((role)=>
        <option key={role.role_name} value={role.role_name}>{role.role_name}</option>
      );
      return(
          <>
            {this.state.show?(
              <div className="container-fluid">
                {this.state.show_content==="view"?(
                    <div className="card shadow mb-2">
                        <div className="card-header py-3">
                            <h4 className="m-0 font-weight-bold text-white">Email Event details</h4>
                        </div>
                        <div className="card-body event-view">
                          <div className="row mt-2">
                            <div className="col-md-2">
                              <span>Event Name</span>
                            </div>
                            <div className="col-md-10">
                              <span className="font-weight-bold text-dark"> {this.state.event_name} </span>
                            </div>
                          </div>
                          <div className="row mt-2">
                            <div className="col-md-2">
                              <span>Template Key </span>
                            </div>
                            <div className="col-md-10">
                              <span className="font-weight-bold text-dark"> {this.state.template_key} </span>
                            </div>
                          </div>
                          <div className="row my-2">
                            <div className="col-md-2">
                              <span>Roles assigned</span>
                            </div>
                            <div className="col-md-10">
                              <span className="font-weight-bold text-dark"> {JSON.stringify(this.state.roles)} </span>
                            </div>
                          </div>
                          <button type="button" className="btn btn-secondary" onClick={()=> this.setState({show:false})}>Close</button>
                        </div>
                    </div>
                ):(
                  <>
                  {this.state.show_content==="form" &&
                    <div className="card shadow mb-2">
                        <div className="card-header py-3">
                            <h4 className="m-0 font-weight-bold text-light">Add / Edit Email event</h4>
                        </div>
                        <div className="card-body email-event-form">
                            <form id="email_eventForm" className="user" onSubmit={this.handleSubmit} autoComplete="off">
                              <div className="row">
                                <div className="col-xs-12 col-md-6">
                                  <label>Event Name</label>
                                  <input type="text" className="form-control" name="event_name" value={this.state.event_name} onChange={this.handleInputChange} required />
                                </div>
                                <div className="col-xs-12 col-md-6">
                                  <label>Template Key </label>
                                  <input type="text" className="form-control" name="template_key" value={this.state.template_key} onChange={this.handleInputChange} required />
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-xs-12 col-md-6">
                                  <label>User Roles </label>
                                  <select className="form-select" name="roles" value={this.state.roles} onChange={this.handleMultiSelectChange} multiple >
                                    <option value=""> -- Select Roles -- </option>
                                    {role_opts}
                                  </select>
                                </div>
                              </div>
                              <div className="form-group mt-2">
                                <input type="submit" id="email-event-submit" className="btn btn-bg-success" value="Submit" />
                                <button type="button" name="cancel" className="btn btn-danger float-right" onClick={()=> this.setState({show:false})}>Cancel</button>
                              </div>
                            </form>
                        </div>
                    </div>
                  }
                  </>
                )}
              </div>
            ):(
              <div className="row">
                  <div className="col-md-12 col-xs-12">
                      <div className="card shadow mb-2">
                          <div className="card-header py-3">
                              <h4 className="m-0 font-weight-bold text-white">Email Events</h4>
                          </div>
                          <div className="card-body">
                              <div className="table-responsive email-event-table">
                                  <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                      <thead>
                                          <tr>
                                              <th>Event Name</th>
                                              <th>Template Key</th>
                                              <th>Roles</th>
                                              <th></th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          {email_event_list}
                                      </tbody>
                                  </table>
                              </div>
                          </div>
                      </div>
                      <button className="btn btn-primary" onClick={this.addEmailEvent}><i className="fas fa-plus"></i> New Email event</button>
                  </div>
              </div>
            )}
          </>
      );
    }
  }
}

function EmailEvents() {
  return (
    <>
        <div id="wrapper">
            <SideNav />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopBar />
                    <div className="container-fluid">
                        <EmailEventList />
                    </div>
                </div>
                <Footer />
            </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
        </a>
        <LogoutModal />
    </>
  );
}

export { EmailEvents };
